import type { ShareToChatSubject } from "@xop/dashboard-shared";

import { documentDeepLink, type ShareableDoc } from "./shareLinks.js";

/**
 * "Share to chat" subject for a documentation file. The summary is a short,
 * non-monetary context line (category + status/version) and the deep link is the
 * reader route (matched by the chat applink allowlist — see
 * packages/shared/src/chat.ts). Documents carry no money, so there is no
 * non-monetary redaction concern here (unlike the CRM customer subject).
 */
export function documentShareSubject(doc: ShareableDoc): ShareToChatSubject {
  const version =
    doc.current_version?.version_number ?? doc.default_release?.version ?? null;
  const summaryLines = [
    doc.category?.name ?? "",
    [doc.status ? `Status: ${doc.status}` : "", version ? `v${version}` : ""]
      .filter(Boolean)
      .join(" · "),
  ];
  return {
    kind: "Document",
    title: doc.title,
    summaryLines,
    deepLinkPath: documentDeepLink(doc),
  };
}
